//ecd:1388468794H20261022084009_V3.0
import { PurchaseOrderDTO } from './PurchaseOrderDTO';

/**
 * PurchaseOrderDTO invariants
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
/**
 * What PurchaseOrderDTO promises about itself, checked here as a courtesy.
 *
 * The server enforces these when the row is written - that is what
 * makes them true. This is so a form can say what is wrong before
 * the request, in the domain's own words.
 *
 * @returns the promises this value breaks, empty when it keeps them
 */
export function violations(purchaseOrder: PurchaseOrderDTO | null | undefined): string[] {
    const broken: string[] = [];
    if (purchaseOrder == null) return broken;
    if (purchaseOrder.lines == null || purchaseOrder.lines.length <= 0) {
        broken.push('the cart is empty');
    }
    return broken;
}

/** Whether PurchaseOrderDTO keeps every promise it makes. */
export function isValid(purchaseOrder: PurchaseOrderDTO | null | undefined): boolean {
    return violations(purchaseOrder).length === 0;
}
